import { ChangeDetectionStrategy, Component, OnInit } from "@angular/core";
import { RouteEnum } from "src/app/shared/models/routes.model";
import { DashboardData } from "src/app/shared/models/dashboard.model";
import { AuthService } from "src/app/shared/services/auth.service";
import { Router } from "@angular/router";
import { Store } from "@ngrx/store";
import { dashboardData } from "src/app/shared/ngrx/ngrx-selectors";
import {
  UI__ROUTE_NAVIGATION,
  UI__SIDEBAR_ROUTE_NAVIGATION,
} from "src/app/shared/ngrx/ngrx-actions";
import { TranslateModule } from "@ngx-translate/core";
import { CommonModule } from "@angular/common";

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: "dash-tasks",
  templateUrl: "./dash-tasks.component.html",
  styleUrls: ["./dash-tasks.component.sass"],
  imports: [TranslateModule, CommonModule],
  standalone: true,
})
export class DashTasksComponent implements OnInit {
  routeEnum: RouteEnum = new RouteEnum();
  displayClinicDelays: boolean;

  get data(): DashboardData {
    return this.store.selectSignal(dashboardData)();
  }

  constructor(
    private readonly store: Store,
    private authService: AuthService,
    private router: Router
  ) {
    this.displayClinicDelays = this.authService.currentUser.org == "LAB";
  }

  ngOnInit(): void {}

  filterOrdersByChatCode(code: string) {
    this._dispatchInboxNavigation();

    this.router.navigate([this.routeEnum.URL_INBOX], {
      queryParams: { chatCode: code, reuse: "false" },
    });
  }

  _dispatchInboxNavigation() {
    this.store.dispatch(
      UI__ROUTE_NAVIGATION({
        data: { link: this.routeEnum.URL_INBOX },
      })
    );

    this.store.dispatch(
      UI__SIDEBAR_ROUTE_NAVIGATION({
        data: { tabId: "inbox" },
      })
    );
  }
}
